import { render } from "./freeDIDNumbers.vue?vue&type=template&id=923d01c4&scoped=true"
import script from "./freeDIDNumbers.vue?vue&type=script&lang=js"
export * from "./freeDIDNumbers.vue?vue&type=script&lang=js"

import "./freeDIDNumbers.vue?vue&type=style&index=0&id=923d01c4&scoped=true&lang=scss"
import "./freeDIDNumbers.vue?vue&type=style&index=1&id=923d01c4&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923d01c4"]])

export default __exports__